import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";


class CloseBannerAction extends BaseAction<void, boolean> {
  override async run(): Promise<void> {
    try {
      sessionStorage.setItem("hideBanner", "true");
      updateRecoilState("getAppBanner", false);
      console.log("Banner visibility hidden from session:");
    } catch (error: any) {
      console.error("Error reading session storage:");
      updateRecoilState("getAppBanner", false);
    }
  }
}

export const closeBannerAction = new CloseBannerAction();
